import { createFileRoute, redirect } from '@tanstack/react-router';
import { EventDocument } from 'shared/__generated__/graphql';
import _ from 'lodash';
import { genMeta } from '../../../utils/meta';
import EventCompose from 'web2/app/routes/event/compose/-compose';
import { getSessionUser } from '../../../actions/getSessionUser';
import { genCDN } from 'shared/cdn';

export const Route = createFileRoute('/event/edit/$eventId')({
  component: RouteComponent,
  staleTime: 60 * 5,
  head(ctx) {
    const data = ctx.loaderData as Awaited<ReturnType<typeof Route.loader>>;

    const event = data?.initialEventData as any;

    const image = genCDN(event?.imageUrl ?? '/pi-image-for-social.png', 70, 'webp');

    return genMeta({
      title: `Edit Event | ${_.truncate(event?.title, { length: 60 }).toUpperCase()}`,
      description: _.truncate(event?.description || 'LEARN MORE', { length: 155 }).toUpperCase(),
      image,
      // TODO REMOVE WHEN EVENTS ARE LIVE
      other: [{ name: 'robots', content: 'noindex' }],
    });
  },
  loader: async ({ params, context }) => {
    const user = await getSessionUser();
    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
    if (user.role !== 'ADMIN') {
      throw redirect({ to: '/' });
    }

    const { eventId } = params;
    if (!eventId) {
      throw new Error('Event ID is required');
    }

    const { data } = await context.apolloClient.query({
      query: EventDocument,
      variables: { eventId: params.eventId },
    });

    const userCanEdit = data?.event?.collaborators.some(
      (collaborator) => collaborator.user.id === user.id,
    );

    if (data?.event && !!userCanEdit) {
      return {
        eventId: params.eventId,
        initialEventData: data?.event,
      };
    }

    throw redirect({ to: '/event/$eventId', params: { eventId: params.eventId } });
  },
});

function RouteComponent() {
  const { initialEventData } = Route.useLoaderData();

  return <EventCompose event={initialEventData} />;
}
